@if (
    !isDescriptor() && filter.field !== 'siteCity' && filter.field !== 'siteStateAbbr' && filter.field !== 'companyID'
) {
    <div> {{ filter.name }}: {{ resultField }} </div>
}
@if (isDescriptor()) {
    <div>
        @for (descriptor of descriptors; track descriptor) {
            <div> {{ descriptor.label }}: {{ descriptor.value }} </div>
        }
    </div>
}
